import { useAppDispatch, useAppSelector } from 'app/hooks';
import { setSystemPtacPreferences } from 'features/structure/structure-slice';
import { useCallback } from 'react';
import { persistPtacPreferences } from 'utils/ptac-preferences-persist';
import { PtacPreferencesRecord } from '@alpinehomeair/common';

export default function usePtacPreferences(systemUniqueId: string) {
  const dispatch = useAppDispatch();
  const entry = useAppSelector(
    (state) => state.structure.recommendationSelectionsBySystem[systemUniqueId]
  );
  const loaded = useAppSelector(
    (state) => state.structure.recommendationSelectionsLoaded
  );
  const record = entry?.ptac ?? null;

  const update = useCallback(
    (next: PtacPreferencesRecord) => {
      dispatch(setSystemPtacPreferences({ systemUniqueId, ptac: next }));
      persistPtacPreferences(systemUniqueId, entry, next);
    },
    [dispatch, entry, systemUniqueId]
  );

  return { record, loaded, update };
}
